<template>
  <div>
    <b-loading :is-full-page="true" :active="!initialized"></b-loading>
    <section v-if="initialized" class="section is-main-section">
      <CardComponent>
        <EventHeader :event="event" />
        <b-button
          tag="router-link"
          type="is-primary"
          :to="{
            name: 'EventDashboard',
            params: { eventid: event._id },
          }"
          class="is-pulled-right"
          >View Dashboard</b-button
        >
        <h1 class="title">Manage Registrations ({{ entries.length }})</h1>

        <b-tabs v-model="activeTab">
          <b-tab-item
            v-for="entrytype in event.entrytypes"
            :key="entrytype"
            :label="entrytype"
          >
            <b-input
              v-if="entries.length > 0"
              v-model="search"
              icon="magnify"
              :expanded="true"
              placeholder="Search by name, email, category or gender"
            />
            <p v-if="filteredEntries.length === 0">No entries available.</p>
            <IndividualEntries
              v-if="entrytype === 'Individual' && filteredEntries.length > 0"
              :entries.sync="filteredEntries"
              :event="event"
              @deleted="removeEntry"
            />
            <TeamEntries
              v-if="entrytype === 'Team' && filteredEntries.length > 0"
              :entries.sync="filteredEntries"
              :event="event"
              @deleted="removeEntry"
            />
          </b-tab-item>
        </b-tabs>
      </CardComponent>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import EventHeader from '@/components/EventHeader'
import CardComponent from '@/components/CardComponent'
import IndividualEntries from '@/components/IndividualEntries'
import TeamEntries from '@/components/TeamEntries'
import EventEntryApi from '@/api/event-entry'

export default {
  name: 'ManageRegistrations',
  components: {
    CardComponent,
    EventHeader,
    IndividualEntries,
    TeamEntries,
  },
  data() {
    return {
      activeTab: 0,
      entries: [],
      search: '',
      initialized: false,
      entryId: null,
      showTeamModal: false,
      showUpdateGymNameModal: false,
    }
  },
  computed: {
    ...mapGetters(['event']),
    filteredEntries: {
      cache: false,
      get() {
        if (this.event && this.entries.length > 0 && this.search === '') {
          return this.entries.filter(
            (entry) => entry.entrytype === this.event.entrytypes[this.activeTab]
          )
        } else if (this.event && this.entries.length > 0) {
          let search = this.search.toLowerCase()
          return this.entries.filter(
            (entry) =>
              entry.entrytype === this.event.entrytypes[this.activeTab] &&
              (entry.user.firstname.toLowerCase().includes(search) ||
                entry.user.surname.toLowerCase().includes(search) ||
                entry.user.email.toLowerCase().includes(search) ||
                entry.entrynumber.toString().toLowerCase().includes(search) ||
                (entry.entrytype === 'Team' &&
                  entry.teamname.toLowerCase().includes(search)))
          )
        }

        return []
      },
    },
  },
  async created() {
    this.entries = await EventEntryApi.entriesForEvent(
      this.$route.params.eventid
    )
    this.initialized = true
  },
  methods: {
    removeEntry(entryId) {
      this.entries = this.entries.filter((entry) => entry._id !== entryId)
    },
  },
}
</script>
